export function normalizeAnalyticsPageIds(pageIds: number[]): number[] {
  return Array.from(new Set(pageIds)).sort((a, b) => a - b);
}
